window.i18n_de = {
  "general": {
    "accessibility": {
      "skip_to_content": "Direkt zum Inhalt",
      "close_modal": "Schließen",
      "link_messages": {
        "new_window": "Öffnet ein neues Fenster.",
        "external": "Öffnet externe Website.",
        "new_window_and_external": "Öffnet externe Website in einem neuen Fenster."
      },
      "refresh_page": "Wenn du eine Auswahl auswählst, wird eine vollständige Seite aktualisiert.",
      "selection_help": "Drücke die die Leertaste und dann die Pfeiltasten, um eine Auswahl zu treffen.",
      "unit_price_separator": "pro",
      "error": "Fehler"
    },
    "meta": {
      "tags": "Getaggt \"{{ tags }}\"",
      "page": "Seite {{ page }}"
    },
    "404": {
      "title": "404 Seite nicht gefunden",
      "subtext": "Die von Ihnen angeforderte Seite existiert nicht.",
      "link": "Einkauf fortzusetzen"
    },
    "pagination": {
      "previous": "Vorherige Seite",
      "next": "Nächste Seite",
      "current_page": "Seite {{ current }} von {{ total }}"
    },
    "password_page": {
      "opening_soon": "Eröffnet demnächst",
      "login_form_heading": "Shop mit Passwort betreten",
      "login_form_password_label": "Passwort",
      "login_form_password_placeholder": "Dein Passwort",
      "login_form_submit": "Betreten",
      "signup_form_email_label": "E-Mail",
      "signup_form_success": "Wir senden Ihnen eine E-Mail, kurz bevor wir eröffnen!",
      "admin_link_html": "Bist du der Shop-Inhaber? <a href=\"/admin\" class=\"text-link\">Logge dich hier ein</a>",
      "password_link": "Mit Passwort betreten"
    },
    "social": {
      "share_on_facebook": "Teilen",
      "share_on_twitter": "Twittern",
      "share_on_pinterest": "Pinnen",
      "alt_text": {
        "share_on_facebook": "Auf Facebook teilen",
        "share_on_twitter": "Auf Twitter twittern",
        "share_on_pinterest": "Auf Pinterest pinnen"
      }
    },
    "search": {
      "empty_search_message": "Suchfeld darf nicht leer sein",
      "title": "Suche auf unserer Seite",
      "placeholder": "Suchen",
      "submit": "Suchen",
      "close": "Schließen (esc)",
      "heading": {
        "one": "Suchergebnis",
        "other": "Suchergebnisse"
      },
      "search_for": "Suchen nach",
      "loading": "Wird geladen",
      "clear_search_term": "Suchbegriffe zurücksetzen",
      "number_of_results": "{{ result_number }} von {{ results_count }}",
      "products": "Produkte",
      "number_of_results_found": "{{ results_count }} Ergebnisse gefunden",
      "one_result_found": "1 Ergebnis gefunden",
      "no_results": "Überprüfe die Schreibweise oder versuche es mit anderen Wörtern.",
      "results_with_count": {
        "one": "{{ count }} Suchergebnis für \"{{ terms }}\"",
        "other": "{{ count }} Suchergebnisse für \"{{ terms }}\""
      }
    },
    "newsletter_form": {
      "newsletter_email": "Abonniere unsere Mailingliste",
      "email_placeholder": "E-Mail-Adresse",
      "confirmation": "Danke für deine Anmeldung!",
      "submit": "Abonnieren"
    },
    "filters": {
      "show_more": "Mehr anzeigen",
      "show_less": "Weniger anzeigen"
    },
    "payment": {
      "method": "Zahlungsmethoden"
    },
    "currency": {
      "dropdown_label": "Währung"
    },
    "language": {
      "dropdown_label": "Sprache"
    }
  },
  "sections": {
    "slideshow": {
      "next_slide": "Nächster Schieber",
      "previous_slide": "Vorheriger Schieber",
      "pause_slideshow": "Slideshow pausieren",
      "rotate_slideshow": "Diashow abspielen",
      "load_slide": "Folie {{ slide_number }} laden",
      "navigation_instructions": "Nutze die linken/rechten Pfeile, um durch die Slideshow zu navigieren, oder wische nach links bzw. rechts, wenn du ein mobiles Gerät verwendest"
    },
    "featured_product": {
      "title": "Vorgestelltes Produkt",
      "gallery_thumbnail_alt": "Lade das Bild in den Galerie-Viewer, {{ imageAlt }}",
      "video_thumbnail_alt": "Laden und Abspielen von Videos im Galerie-Viewer, {{ imageAlt }}",
      "model_thumbnail_alt": "Laden das 3D-Modell in den Galerie-Viewer, {{ imageAlt }}"
    },
    "map": {
      "address_error": "Kann die Adresse nicht finden",
      "address_no_results": "Keine Ergebnisse für diese Adresse",
      "address_query_limit_html": "Du hast die Nutzungsgrenze der Google-API überschritten. Du solltest über ein Upgrade auf einen <a href=\"https://developers.google.com/maps/premium/usage-limits\">Premium-Plan</a> nachdenken.",
      "auth_error_html": "Es gab ein Problem bei der Authentifizierung deineses Google Maps-Kontos.",
      "section_heading": "Standort"
    },
    "video": {
      "play": "Video {{ video_title }} abspielen",
      "pause": "Video {{ video_title }} pausieren",
      "resume": "Video {{ video_title }} fortsetzen",
      "close": "Video {{ video_title }} schließen"
    },
    "header": {
      "announcement_bar_label": "Ankündigung"
    }
  },
  "blogs": {
    "article": {
      "view_all": "Alle anzeigen",
      "view_all_blogs": "Alle anzeigen Artikel",
      "all_topics": "Alle themen",
      "by_author": "von {{ author }}",
      "posted_in": "Veröffentlicht in",
      "read_more": "Weiterlesen",
      "read_more_title": "Weiterlesen: {{ title }}",
      "back_to_blog": "Zurück zu {{ title }}",
      "tags": "Stichworte",
      "article_with_count": {
        "one": "{{ count }} Artikel",
        "other": "{{ count }} Artikel"
      }
    },
    "comments": {
      "title": "Hinterlasse einen Kommentar",
      "name": "Name",
      "email": "E-Mail",
      "message": "Nachricht",
      "post": "Kommentar posten",
      "moderated": "Bitte beachten Sie, dass Kommentare vor der Veröffentlichung freigegeben werden müssen",
      "success_moderated": "Dein Kommentar wurde erfolgreich gepostet. Da unser Blog moderiert wird, werden wir ihn erst kurze Zeit später veröffentlichen.",
      "success": "Dein Kommentar wurde erfolgreich gepostet. Danke!",
      "unapproved": "Die angegebene E-Mail-Adresse ist nicht zum Posten von Kommentaren freigegeben.",
      "comments_with_count": {
        "one": "{{ count }} Kommentar",
        "other": "{{ count }} Kommentare"
      }
    }
  },
  "cart": {
    "general": {
      "title": "Warenkorb",
      "note": "Einen Hinweis zu Ihrer Bestellung hinzufügen",
      "removed_item_html": "<span class=\"cart__removed-product-details\">({{ quantity }}) {{ link }}</span> aus deinem Warenkorb entfernt.",
      "remove": "Entfernen",
      "subtotal": "Zwischensumme",
      "savings": "Du sparst",
      "taxes_and_shipping_at_checkout": "Steuern und Versandkosten werden beim Checkout berechnet",
      "taxes_and_shipping_policy_at_checkout_html": "zzgl. MwSt. und <a href=\"{{ link }}\">Versandkosten</a>",
      "taxes_included_but_shipping_at_checkout": "inkl. MwSt. und zzgl. Versandkosten",
      "taxes_included_and_shipping_policy_html": "inkl. MwSt. zzgl. <a href=\"{{ link }}\">Versandkosten</a>",
      "update": "Warenkorb aktualisieren",
      "checkout": "Checkout",
      "empty": "Dein Warenkorb ist im Moment leer.",
      "cookies_required": "Aktiviere Cookies, um den Warenkorb benutzen zu können",
      "continue_shopping": "Weiter einkaufen",
      "cart_error": "Beim Aktualisieren des Warenkorbs ist ein Fehler aufgetreten. Bitte versuche es erneut."
    },
    "label": {
      "discounted_total": "Gesamtrabatt",
      "product": "Artikel",
      "price": "Preis",
      "price_column": "Rabattdetails findest du in der Preisspalte.",
      "product_details": "Produktdetails",
      "quantity": "Menge",
      "qty": "Menge",
      "regular_total": "Normaler Gesamtpreis",
      "remove": "{{ product }} entfernen",
      "total": "Gesamt",
      "update": "Warenkorb aktualisieren"
    },
    "popup": {
      "added_to_cart": "Zum Warenkorb hinzugefügt",
      "cart_count": {
        "one": "{{ count }} Artikel",
        "other": "{{ count }} Produkte"
      },
      "product_details": "Produktdetails",
      "quantity": "Menge",
      "quantity_label": "Menge: {{ quantity_count }}"
    }
  },
  "collections": {
    "general": {
      "view_all": "Alle anzeigen",
      "view_all_label": "Sehe alle Produkte in der {{ collection_name }}-Sammlung",
      "no_matches": "Es tut uns leid, aber deine Suche nach Produkten hat keine Treffer ergeben.",
      "items_with_count": {
        "one": "{{ count }} Produkt",
        "other": "{{ count }} Produkte"
      },
      "collection_label": "Kategorie"
    },
    "catalog": {
      "title": "Katalog"
    },
    "sorting": {
      "title": "Sortieren nach"
    },
    "filters": {
      "title_tags": "Filtern nach",
      "all_tags": "Alle Produkte"
    }
  },
  "contact": {
    "form": {
      "name": "Name",
      "email": "E-Mail",
      "phone": "Telefonnummer",
      "message": "Nachricht",
      "submit": "Absenden",
      "post_success": "Danke, dass du uns kontaktiert hast. Wir werden uns so schnell wie möglich bei dir melden.",
      "error_heading": "Bitte passe Folgendes an:"
    }
  },
  "customer": {
    "account": {
      "title": "Mein Konto",
      "details": "Kontodetails",
      "view_addresses": "Adressen ansehen",
      "return": "Zurück zu Kontodetails"
    },
    "activate_account": {
      "title": "Konto aktivieren",
      "subtext": "Erstelle ein Passwort, um dein Konto zu aktiveren.",
      "password": "Passwort",
      "password_confirm": "Passwort bestätigen",
      "submit": "Konto aktivieren",
      "cancel": "Einladung ablehnen"
    },
    "addresses": {
      "title": "Deine Adressen",
      "default": "Standard",
      "add_new": "Neue Adresse hinzufügen",
      "edit_address": "Adresse bearbeiten",
      "first_name": "Vorname",
      "last_name": "Nachname",
      "company": "Firma",
      "address1": "Adresse",
      "address2": "Wohnung, Zimmer usw.",
      "city": "Stadt",
      "country": "Land / Region",
      "province": "Bundesland",
      "zip": "PLZ",
      "phone": "Telefon",
      "set_default": "Als Standard-Adresse festlegen",
      "add": "Adresse hinzufügen",
      "update": "Adresse aktualisieren",
      "cancel": "Abbrechen",
      "edit": "Bearbeiten",
      "delete": "Löschen",
      "delete_confirm": "Bist du sicher, dass du diese Adresse löschen möchtest?"
    },
    "login": {
      "title": "Login",
      "email": "E-Mail",
      "password": "Passwort",
      "forgot_password": "Hast du dein Passwort vergessen?",
      "sign_in": "Anmelden",
      "guest_title": "Als Gast fortsetzen",
      "guest_continue": "Fortsetzen"
    },
    "orders": {
      "title": "Bestellhistorie",
      "order_number": "Bestellung",
      "order_number_link": "Bestellnummer {{ number }}",
      "date": "Datum",
      "payment_status": "Zahlungsstatus",
      "fulfillment_status": "Lieferstatus",
      "total": "Gesamt",
      "none": "Du hast noch keine Bestellungen aufgegeben."
    },
    "order": {
      "title": "Bestellung {{ name }}",
      "date_html": "Aufgegeben am {{ date }}",
      "cancelled_html": "Bestellung storniert am {{ date }}",
      "cancelled_reason": "Grund: {{ reason }}",
      "billing_address": "Rechnungsadresse",
      "payment_status": "Zahlungsstatus",
      "shipping_address": "Lieferadresse",
      "fulfillment_status": "Lieferstatus",
      "discount": "Rabatt",
      "shipping": "Versand",
      "tax": "Steuern",
      "product": "Artikel",
      "sku": "SKU",
      "price": "Preis",
      "quantity": "Menge",
      "total": "Gesamt",
      "fulfilled_at_html": "Geliefert am {{ date }}",
      "subtotal": "Zwischensumme",
      "track_shipment": "Sendung verfolgen"
    },
    "recover_password": {
      "title": "Passwort zurücksetzen",
      "email": "E-Mail",
      "submit": "Absenden",
      "cancel": "Abbrechen",
      "subtext": "Wir werden Ihnen eine E-Mail zum Zurücksetzen des Passworts schicken.",
      "success": "Wir haben Ihnen eine E-Mail mit einem Link zum Aktualisieren des Passworts geschickt."
    },
    "reset_password": {
      "title": "Passwort für Konto zurücksetzen",
      "subtext": "Gib ein neues Passwort für {{ email }} ein",
      "password": "Passwort",
      "password_confirm": "Passwort bestätigen",
      "submit": "Passwort zurücksetzen"
    },
    "register": {
      "title": "Konto erstellen",
      "first_name": "Vorname",
      "last_name": "Nachname",
      "email": "E-Mail",
      "password": "Passwort",
      "submit": "Erstellen"
    }
  },
  "homepage": {
    "general": {
      "title": "Startseite"
    },
    "onboarding": {
      "product_title": "Der Name deines Produkts",
      "product_description": "Diesen Abschnitt kannst du nutzen, um die Details deines Produkts zu beschreiben. Erzähle den Kunden, wie dein Produkt aussieht, sich anfühlt und designt ist. Füge Einzelheiten zu Farbe, verwendeten Materialien, Größe und Produktionsort hinzu.",
      "collection_title": "Name Ihrer Kategorie",
      "blog_title": "Der Titel deines Posts",
      "blog_excerpt": "Dein Shop hat noch keine Blogposts veröffentlicht. Ein Blog kann genutzt werden, um über die Einführung neuer Produkte, Tipps oder andere Neuigkeiten, die du mit deinen Kunden teilen möchtest, zu berichten. Für Inspiration und Ratschläge für deinen eigenen Shop und Blog kannst du den E-Commerce-Blog von Shopify besuchen.",
      "blog_author": "Name des Autors",
      "no_content": "Dieser Bereich hat zur Zeit keinen Inhalt. Füge diesem Bereich über die Seitenleiste Inhalte hinzu."
    }
  },
  "layout": {
    "navigation": {
      "search": "Suchen",
      "expand": "ausklappen",
      "collapse": "einklappen",
      "menu": "Menü"
    },
    "cart": {
      "title": "Warenkorb",
      "items_count": {
        "one": "Produkt",
        "other": "Produkte"
      }
    },
    "customer": {
      "account": "Konto",
      "log_out": "Ausloggen",
      "log_in": "Einloggen",
      "create_account": "Konto erstellen"
    },
    "footer": {
      "social_platform": "{{ name }} auf {{ platform }}"
    }
  },
  "products": {
    "product": {
      "regular_price": "Normaler Preis",
      "sold_out": "Ausverkauft",
      "unavailable": "Nicht verfügbar",
      "on_sale": "Angebot",
      "sale_price": "Sonderpreis",
      "quantity": "Menge",
      "add_to_cart": "In den Warenkorb legen",
      "loader_label": "Produkt wird zum Warenkorb hinzugefügt",
      "back_to_collection": "Zurück zu {{ title }}",
      "vendor": "Verkäufer",
      "quantity_minimum_message": "Die Menge muss 1 oder mehr sein",
      "include_taxes": "inkl. MwSt.",
      "shipping_policy_html": "zzgl. <a href=\"{{ link }}\">Versandkosten</a>",
      "unit_price_label": "Einzelpreis",
      "view_cart": "Warenkorb einsehen",
      "availability": "Verfügbarkeit",
      "from_lowest_price_html": "von {{ lowest_price }}",
      "view_in_space": "In deinem Bereich ansehen",
      "view_in_space_label": "„Ansicht in deinem Raum“ lädt den Artikel im Augmented-Reality-Fenster"
    }
  },
  "gift_cards": {
    "issued": {
      "title_html": "Hier ist dein {{ value }} Geschenkgutschein für {{ shop }}!",
      "subtext": "Hier ist dein Geschenkgutschein!",
      "gift_card_code": "Gutscheincode",
      "disabled": "Deaktiviert",
      "expired": "Abgelaufen am {{ expiry }}",
      "active": "Läuft ab am {{ expiry }}",
      "redeem_html": "Nutze beim Checkout diesen Code, um deinen {{ value }} Geschenkgutschein einzulösen",
      "shop_link": "Einkauf beginnen",
      "print": "Diesen Geschenkgutschein ausdrucken",
      "remaining_html": "{{ balance }} übrig",
      "add_to_apple_wallet": "Hinzufügen zu Apple Wallet",
      "qr_image_alt": "QR-Code — Scannen, um Geschenkgutschein einzulösen"
    }
  },
  "store_availability": {
    "general": {
      "view_store_info": "Shop-Informationen anzeigen",
      "check_other_stores": "Verfügbarkeit in anderen Shops überprüfen",
      "pick_up_available": "Abholung verfügbar",
      "pick_up_currently_unavailable": "Abholung derzeit nicht verfügbar",
      "pick_up_available_at_html": "Abholung bei <strong>{{ location_name }}</strong> verfügbar",
      "pick_up_unavailable_at_html": "Abholung bei <strong>{{ location_name }}</strong> derzeit nicht verfügbar"
    }
  },
  "dynosim": {
    "auto": {
      "multiple_sessions_detected": "Mehrere Sitzungen erkannt",
      "your_account_is_active_in_another_window": "Dein Konto ist in einem anderen Fenster oder Gerät aktiv. Schließe die andere Sitzung, um AlphaX Tuning Sim weiter zu nutzen.",
      "alphax_tuning_simulator": "AlphaX Tuning Simulator",
      "garage_tuning": "Garage (Tuning)",
      "dynamometer": "Leistungsprüfstand",
      "drag_strip": "Drag Strip",
      "leaderboards": "Bestenlisten",
      "login": "Login",
      "import_tune": "MAP IMPORTIEREN",
      "export_tune": "Map exportieren",
      "start_engine": "MOTOR STARTEN",
      "rpm": "RPM",
      "147": "14.7",
      "afr": "AFR",
      "status": "Status:",
      "off": "AUS",
      "map": "MAP:",
      "101_kpa": "101 kPa",
      "boost": "Ladedruck:",
      "00_psi": "0.0 psi",
      "config": "Konfig:",
      "twin_turbo": "TWIN TURBO",
      "tps": "TPS:",
      "0": "0%",
      "timing": "Zündung:",
      "knk_retard": "KNK Korrektur:",
      "knock_count": "Klopfzähler:",
      "inj_pw_cyl_1": "Einspritzzeit (Zyl 1):",
      "00_ms": "0.0 ms",
      "vvt_intake": "VVT Einlass:",
      "vvt_exhaust": "VVT Auslass:",
      "coolant_temp": "Kühlmitteltemp:",
      "_": "+ / - / *",
      "ethanol": "Ethanol:",
      "fuel_rail": "Kraftstoffrail:",
      "_psi": "-- PSI",
      "stft": "STFT:",
      "pump_load": "Pumpenlast:",
      "battery": "Batterie:",
      "125_v": "12.5 V",
      "max_pedal_tps": "Max Pedal TPS",
      "100": "100%",
      "throttle_hold": "Drosselklappe halten",
      "pedal": "PEDAL",
      "ecu_flags": "ECU FLAGS:",
      "engine_limits": "Motorgrenzen",
      "trigger": "Trigger",
      "adv_uo": "Nur für fortgeschrittene Benutzer!",
      "smart_alternator": "Intelligente Lichtmaschine",
      "axis_wizard": "Achsen-Assistent",
      "ve_table": "VE Tabelle",
      "target_afr_table": "Ziel-AFR Tabelle",
      "fuel_settings": "Kraftstoffeinstellungen",
      "flex_fuel": "Flex Fuel",
      "closed_loop_fuel": "Closed Loop Kraftstoff",
      "accel_enrichment": "Beschleunigungsanreicherung",
      "ignition_advance": "Zündzeitpunkt",
      "ignition_settings": "Zündungseinstellungen",
      "knock_control": "Klopfregelung",
      "vvt_intake_target": "VVT Einlass Ziel",
      "vvt_exhaust_target": "VVT Auslass Ziel",
      "vvt_vtec_settings": "VVT / VTEC Einstellungen",
      "idle": "Leerlauf",
      "cranking": "Startvorgang",
      "upgrades_mods": "Upgrades & Mods",
      "nitrous_system": "Lachgassystem",
      "wastegate_duty_table": "Wastegate Duty Tabelle",
      "cl_boost_target": "CL Ladedruck-Ziel",
      "launch_control": "Launch Control",
      "simulation_settings": "Simulations-Einstellungen",
      "simple": "SIMPLE",
      "adv": "ADV",
      "buy_advanced_mode": "Advanced Mode kaufen!",
      "log_off": "LOG OFF",
      "selection_tools": "Auswahl-Werkzeuge:",
      "interp_x_row": "Interp X (Zeile)",
      "interp_y_col": "Interp Y (Spalte)",
      "interp_2d_area": "Interp 2D (Bereich)",
      "keys_hinterp_x_vinterp_y_iinterp_2d_gtlt": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "ve_table_load_vs_rpm": "VE Tabelle (Last vs RPM)",
      "higher_numbers_more_fuel_adjust_to_hit_t": "Höhere Zahlen = mehr Kraftstoff. Anpassen, um Ziel-AFR zu erreichen.",
      "target_afr_table_load_vs_rpm": "Ziel-AFR Tabelle (Last vs RPM)",
      "commanded_airfuel_ratio_core_part_of_the": "Befohlener Luft-Kraftstoff-Verhältnis. Kernbestandteil der Speed-Density-Gleichung.",
      "fuel_injector_settings": "Kraftstoff- & Injektoreinstellungen",
      "injector_size_ccmin": "Injektorgröße (cc/min)",
      "injector_reference_pressure_kpa": "Injektor-Referenzdruck (kPa)",
      "dead_time_ms_by_v": "Totzeit (ms nach V)",
      "c": "°C",
      "multiplier_at_each_iat_10_no_change_09_1": "Multiplikator bei jedem IAT. 1.0 = keine Änderung, 0.9 = -10%, 1.1 = +10%.",
      "ect_fuel_enrichment_": "ECT Kraftstoffanreicherung (×)",
      "fuel_multiplier_on_cold_start_10_no_corr": "Kraftstoffmultiplikator bei Kaltstart. 1.0 = keine Korrektur bei Betriebstemp.",
      "fuel_octane": "Kraftstoff-Oktan",
      "87_aki_regular": "87 AKI (Normal)",
      "91_aki_premium": "91 AKI (Super)",
      "93_aki_premium": "93 AKI (Super Plus)",
      "100_aki_race_gas": "100 AKI (Rennbenzin)",
      "104_aki_race_gas": "104 AKI (Rennbenzin)",
      "116_aki_methanolrace": "116+ AKI (Methanol/Race)",
      "display_afr_as_lambda_3_decimals": "AFR als Lambda anzeigen (3 Dezimalstellen)",
      "enable_fuel_pressure_model": "Kraftstoffdruckmodell aktivieren",
      "base_fuel_pressure_psi": "Basis-Kraftstoffdruck (PSI)",
      "fuel_system_type": "Kraftstoffsystem-Typ",
      "return_style_rising_rate": "Return Style (steigende Rate)",
      "returnless_fixed_pressure": "Returnless (fester Druck)",
      "return_style_rail_rises_11_with_boost_in": "Return style: Rail-Druck steigt 1:1 mit Ladedruck. Returnless: fester Rail-Druck, Injektor-Durchfluss sinkt unter Ladedruck.",
      "apply_settings": "Einstellungen übernehmen",
      "ignition_timing_table_load_vs_rpm": "Zündungs-Tabelle (Last vs RPM)",
      "degrees_before_top_dead_center_too_much_": "Grad vor oberem Totpunkt. Zu viel Vorzündung verursacht Klopfen.",
      "flex_fuel_sensor_simulation": "Flex-Fuel Sensor Simulation",
      "moving_this_slider_simulates_adding_etha": "Diesen Schieberegler zu bewegen simuliert das Hinzufügen von Ethanol.",
      "enable_flex_fuel_tuning_populate_flex_ta": "Flex-Fuel Tuning aktivieren",
      "ethanol_content_": "Ethanolgehalt (%)",
      "apply_content": "Gehalt anwenden",
      "flex_fuel_ve_adder_": "Flex-Fuel VE Addierer (%)",
      "blend_curve_0_100_x_base_map_map_vs_rpm": "Mischkurve (0-100%) x Basis-Map (MAP vs RPM)",
      "flex_fuel_afr_offset": "Flex-Fuel AFR Offset",
      "flex_fuel_timing_adder_deg": "Flex-Fuel Zündungsaddierer (deg)",
      "flex_fuel_boost_duty_adder_": "Flex-Fuel Ladedruck-Duty Addierer (%)",
      "blend_curve_0_100_x_base_map_tps_vs_rpm": "Mischkurve (0-100%) x Basis-Map (TPS vs RPM)",
      "closed_loop_fuel_stft": "Closed-Loop Kraftstoff (STFT)",
      "enable_closed_loop_correction": "Closed-Loop Korrektur aktivieren",
      "deadband_": "Totzone (%)",
      "lambda_error_within_this_band_is_ignored": "Lambda-Fehler innerhalb dieses Bandes wird ignoriert.",
      "tps_lt_5_rpm_near_idle_target": "(TPS < 5%, RPM nahe Leerlaufziel)",
      "time_constant_s": "Zeitkonstante (s)",
      "gain_00833_s": "Gain: 0.0833 /s",
      "min_correction_": "Min Korrektur (%)",
      "max_correction_": "Max Korrektur (%)",
      "part_throttle_cruise": "(Teillast / Cruising)",
      "gain_01250_s": "Gain: 0.1250 /s",
      "tps_gt_90": "(TPS > 90%)",
      "gain_02000_s": "Gain: 0.2000 /s",
      "acceleration_enrichment": "Beschleunigungsanreicherung",
      "corrects_fueling_during_rapid_throttle_o": "Korrigiert die Kraftstoffzufuhr bei schnellen Drosselklappenöffnungen.",
      "mode": "MODUS:",
      "none_disabled": "Keiner (Deaktiviert)",
      "ms_adder": "MS Addierer",
      "map_prediction": "MAP Vorhersage",
      "accel_time_s": "Beschl.-Zeit (s)",
      "hard_cutoff_duration_of_enrichment_event": "Hard cutoff duration of enrichment event",
      "decay_rate": "Abfallrate",
      "ms_mode_mss_middot_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "ms_adder_dtps_s_vs_rpm_rarr_ms": "MS Addierer (dTPS %/s vs RPM → ms)",
      "extra_injection_ms_on_tip_in_y_tps_rate_": "Zusätzliche Einspritz-ms bei Tip-In.",
      "map_prediction_tps_vs_rpm_rarr_kpa": "MAP Vorhersage (TPS % vs RPM → kPa)",
      "predicted_map_for_veafrtiming_lookups_du": "Predicted MAP for VE/AFR/timing lookups during tip-in. Y = TPS %, X = RPM.",
      "ignition_system_mode": "Zündsystem Modus",
      "sets_coil_topology_recharge_time_and_mel": "Sets coil topology, recharge time, and melt behavior.",
      "distributor_single_coil": "Verteiler (Einzelspule)",
      "wasted_spark_n2_coils": "Wasted Spark (N/2 Spulen)",
      "fully_sequential_cop": "Vollsequentiell / COP",
      "spark_plug_gap_inches": "Zündkerzenabstand (Zoll)",
      "wider_gap_needs_more_dwell_to_fire_under": "Wider gap = needs more dwell to fire. Under boost, effective gap shrinks 0.005&quot; per 10 psi — tighter gaps recommended on boosted builds.",
      "degrees_of_retard_at_each_iat_0_no_retar": "Grad Korrektur bei jedem IAT. 0 = keine Korrektur.",
      "coil_dwell_time_ms_by_battery_v": "Spulenschließzeit (ms nach Batterie V)",
      "coil_charge_time_low_voltage_during_cran": "Coil charge time. Low voltage during cranking may cause weak spark.",
      "knock_sensor_spectrogram": "Klopf-Spektrogramm",
      "pause": "PAUSE",
      "cyan_noise_level_nbspnbsp_red_dashed_thr": "Cyan = Geräuschpegel | Rot gestrichelt = Schwelle",
      "_25s": "-2.5s",
      "now": "Jetzt",
      "knock_threshold_db_vs_rpm": "Klopfschwelle (dB vs RPM)",
      "noise_level_above_which_a_knock_event_tr": "Noise level above which a knock event triggers retard. At idle background noise is ~-26 dB; knock spikes to ~-2 dB.\n                                Set each cell just below the lowest knock spike at that RPM. Default -10 dB is a good starting point at lower RPM.\n                                At high RPM you may need to lower to -15 dB or below to avoid false positives.",
      "control_parameters": "Regelparameter",
      "enable_knock_control": "Klopfregelung aktivieren",
      "complete_knock_frequency_calibration_bel": "Complete Knock Frequency Calibration below to unlock.",
      "attack_degevent": "Attack (deg/Event)",
      "degrees_removed_per_knock_detection_0510": "Degrees removed per knock detection. 0.5–10°",
      "max_retard_deg": "Max Korrektur (deg)",
      "maximum_accumulated_retard_120": "Maximum accumulated retard. 1–20°",
      "recovery_rate_degrev": "Erholungsrate (deg/rev)",
      "degrees_recovered_per_engine_revolution_": "Degrees recovered per engine revolution. 0.1–2.0",
      "min_tps_to_engage_": "Min TPS zum Aktivieren (%)",
      "suppresses_retard_below_this_throttle_po": "Suppresses retard below this throttle position. Prevents false triggers on decel pops.",
      "min_map_to_engage_kpa": "Min MAP zum Aktivieren (kPa)",
      "suppresses_retard_below_this_manifold_pr": "Suppresses retard below this manifold pressure. 60 kPa ≈ light cruise.",
      "knock_control_frequency_calibration_mode": "Klopfregelungs-Frequenzkalibrierung",
      "enter_calibration_mode": "Kalibrierungsmodus starten",
      "identify_the_engines_natural_knock_reson": "Identifiziere die natürliche Klopfresonanzfrequenz des Motors.",
      "formula_f_573_boremm_nbspnbsp_81_mm_bore": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "20k": "20k",
      "15k": "15k",
      "10k": "10k",
      "5k": "5k",
      "_5_seconds_ago": "← 5 seconds ago",
      "now_": "Now →",
      "center_freq_khz": "Mittenfreq (kHz)",
      "khz": "kHz",
      "temp_timing_adder": "Temp Zündungsaddierer",
      "_for": "° for",
      "s": "s",
      "apply": "Anwenden",
      "confirm_calibration": "Kalibrierung bestätigen",
      "recalibrate": "Rekalibrieren",
      "nitrous_oxide_system": "Lachgassystem",
      "upgrades_amp_mods": "Upgrades & Mods",
      "n2o_jet_size_thousandths_in": "N2O Düsengröße (tausendstel Zoll)",
      "estimated_power": "Geschätzte Leistung",
      "_337_hp": "≈ 33.7 HP",
      "fuel_jet_size_thousandths_in": "Kraftstoff-Düsengröße (tausendstel Zoll)",
      "wet_shot_fuel_solenoid_handles_base_enri": "Wet shot: fuel solenoid handles base enrichment. ECU VE comp adds on top.",
      "activation_mode": "Aktivierungsmodus",
      "button_switch": "Knopf / Schalter",
      "ecu_control": "ECU Steuerung",
      "ecu_control_parameters": "ECU Steuerungsparameter",
      "min_tps_": "Min TPS (%)",
      "min_rpm": "Min RPM",
      "max_rpm": "Max RPM",
      "max_map_kpa": "Max MAP (kPa)",
      "afr_safety_cut_lean": "AFR Sicherheitsabschaltung (mager)",
      "fuel_ve_comp_": "Kraftstoff-VE Komp. (%)",
      "extra_fuel_when_n2o_is_active_dry_primar": "Extra fuel when N2O is active. Dry = primary comp. Wet = supplement on top of fuel solenoid.",
      "timing_retard_": "Zündungs-Korrektur (°)",
      "degrees_pulled_from_commanded_timing_whe": "Degrees pulled from commanded timing when N2O is active.",
      "apply_nitrous_settings": "Lachgas-Einstellungen übernehmen",
      "vvt_intake_advance_target_load_vs_rpm": "VVT Einlass-Vorverstellung Ziel (Last vs RPM)",
      "positive_degrees_of_intake_cam_advance_i": "Positive degrees of intake cam advance. Interpolates absolute \"In_X\" engine maps.",
      "vvt_exhaust_retard_target_load_vs_rpm": "VVT Auslass-Spätverstellung Ziel (Last vs RPM)",
      "negative_degrees_of_exhaust_cam_retard_i": "Negative degrees of exhaust cam retard. Interpolates absolute \"Ex_X\" engine maps.",
      "variable_valve_lift_vvl_vtec": "Variabler Ventillift (VVL / VTEC)",
      "vvl_high_cam_switch_rpm": "VVL / High Cam Umschaltung (RPM)",
      "vvl_high_cam_min_tps_": "VVL / High Cam Min TPS (%)",
      "vvl_fuel_adder_ve_": "VVL Kraftstoffaddierer (VE %)",
      "vvl_timing_adder_": "VVL Zündungsaddierer (°)",
      "continuous_vvt_phase_angles_are_controll": "Continuous VVT phase angles are controlled via the 9x9 tables.",
      "closed_loop_pid_control": "Closed Loop PID Steuerung",
      "enable_closed_loop_pid_control": "Closed Loop PID Steuerung aktivieren",
      "proportional_kp": "Proportional (Kp)",
      "integral_ki": "Integral (Ki)",
      "derivative_kd": "Differenzial (Kd)",
      "higher_kp_faster_response_ki_eliminates_": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "wastegate_duty_table_tps_vs_rpm": "Wastegate Duty Tabelle (TPS vs RPM)",
      "commanded_wastegate_solenoid_duty_cycle_": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "cl_boost_target_table_tps_vs_rpm": "CL Ladedruck-Ziel Tabelle (TPS vs RPM)",
      "target_boost_pressure_in_psi_used_when_c": "Target boost pressure in PSI. Used when Closed-Loop Boost is enabled in Mod Settings. 0 = match wastegate spring pressure. The WG Duty table is the feed-forward base; the PID adjusts duty to hit this target.",
      "rev_limit_rpm": "Drehzahlbegrenzer",
      "rev_limit_hysteresis_rpm": "Begrenzer-Hysteresse (RPM)",
      "fuel_cut": "Kraftstoffabschaltung",
      "spark_cut": "Zündungsabschaltung",
      "enable_decel_fuel_cut": "Schubabschaltung aktivieren",
      "cut_delay_sec": "Abschaltverzögerung (Sek)",
      "boost_protection": "Ladedruckschutz",
      "boost_cut_psi": "Ladedruck-Abschaltung (psi)",
      "hysteresis_psi": "Hysteresse (psi)",
      "trigger_calibration": "Trigger-Kalibrierung",
      "timing_light_mode": "Zündlichtpistolen-Modus",
      "simulates_a_timing_light_check_engine_st": "Simulates a timing light check. Engine start is disabled while active.",
      "must_match_engine_base_offset_affects_ti": "must match engine base offset — affects timing at all times",
      "fixed_timing_ecu_commanded_045_btdc": "Fixed Timing — ECU commanded (0–45° BTDC)",
      "enable_smart_alternator": "Intelligente Lichtmaschine aktivieren",
      "alt_pressure_rises_05_v_per_1000_rpm_pid": "Alt pressure rises +0.5 V per 1000 RPM. PID controls duty to hold target voltage.",
      "p_gain": "P Gain",
      "i_gain": "I Gain",
      "d_gain": "D Gain",
      "alternator_duty": "Lichtmaschinenlast:",
      "na": "N/A",
      "axis_setup_wizard": "Achsen-Setup Assistent",
      "sets_the_16_point_rpm_and_map_load_axes_": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "base_rpm": "Basis RPM",
      "base_kpa_min_load": "Basis kPa (Min Last)",
      "max_kpa": "Max kPa",
      "apply_axis_wizard": "Assistent anwenden",
      "reset_to_default": "Zurücksetzen",
      "note_existing_tune_values_are_interpolat": "Note: existing tune values are interpolated/extrapolated onto the new axes. Values beyond your current range are linearly extrapolated from the edge trend.",
      "idle_settings": "Leerlaufeinstellungen",
      "maximum_idle_tps": "Maximaler Leerlauf-TPS",
      "actual_throttle_when_duty_curve_reads_10": "Actual throttle % when duty curve reads 100%.",
      "idle_control_rpm_upper_limit": "Leerlaufregelung RPM Obergrenze",
      "idle_control_disengages_above_target_rpm": "Idle control disengages above Target RPM + this value.",
      "target_idle_rpm_vs_coolant_temp": "Ziel Leerlauf-RPM vs Kühlmitteltemp",
      "idle_rpm_target_by_coolant_temperature_r": "Idle RPM target by coolant temperature. Runs higher when cold.",
      "idle_duty_vs_coolant_temp_": "Leerlauf Duty vs Kühlmitteltemp (%)",
      "_of_maximum_idle_tps_to_command_at_each_": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "closed_loop_idle_ignition": "Leerlaufzündung Closed Loop",
      "uses_ignition_timing_to_maintain_target_": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "p": "P",
      "i": "I",
      "d": "D",
      "cranking_starting": "Starten / Anlassen",
      "base_ve": "Basis VE",
      "max_crank_rpm": "Max Start-RPM",
      "decay_s": "Abfall (s)",
      "crank_time_s": "Startzeit (s)",
      "cranking_idle_air_duty_vs_coolant_temp_": "Start-Leerlaufluft Duty vs Kühlmitteltemp (%)",
      "throttle_position_air_during_cranking_hi": "Throttle position (air) during cranking. Higher when cold to overcome friction.",
      "post_crank_enrichment_vs_coolant_temp_ve": "Nachstart-Anreicherung vs Kühlmitteltemp (×VE)",
      "fuel_multiplier_applied_immediately_afte": "Fuel multiplier applied immediately after cranking ends. 1.0 = no enrichment.",
      "post_crank_decay_cycles": "Nachstart-Abfallzyklen",
      "engine_cycles_720_each_for_enrichment_to": "Engine cycles (720° each) for enrichment to decay from curve value to 1.0×.",
      "vehicle_upgrades": "Fahrzeug-Upgrades",
      "export_mod_list": "MOD-LISTE EXPORTIEREN",
      "import_mod_list": "MOD-LISTE IMPORTIEREN",
      "mod_collection": "Mod-Sammlung",
      "tuner_warning_extreme_mods_like_heavy_ca": "TUNER WARNING: Extreme mods like heavy cams will increase idle vacuum penalty (raises base MAP), which can stall your engine! You will need to tune your low-RPM fuel/timing and raise target idle RPM to compensate.",
      "launch_control_two_step": "Launch Control / Two-Step",
      "enable_launch_control": "Launch Control aktivieren",
      "launch_rpm": "Launch RPM",
      "hysteresis_rpm": "Hysteresse (RPM)",
      "window_size_rpm": "Fenstergröße (RPM)",
      "cut_type": "Abschaltungsart",
      "ignition_cut": "Zündungsabschaltung",
      "both_hard_cut": "Beide (Harter Cut)",
      "window_start_timing_deg": "Fensterstart Zündung (deg)",
      "limit_timing_deg_absolute": "Limit Zündung (deg absolut)",
      "fuel_adder_afr_": "Kraftstoffaddierer (AFR %)",
      "activate_two_step_mode_switch": "Two-Step Schalter aktivieren",
      "test_your_launch_settings_in_the_garage_": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "ambient_conditions_used_as_the_baseline_": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "unit_system": "Einheitensystem",
      "affects_all_displayed_temperatures_press": "Affects all displayed temperatures, pressures, and speed. AFR/Lambda can be toggled separately by clicking the gauge.",
      "pressure_display_mode": "Druckanzeige-Modus",
      "absolute": "Absolut",
      "gauge": "Relativ",
      "switches_pressure_on_y_axes_and_gauges": "Wechselt den Druck auf Y-Achsen und Anzeigen zwischen absolut und relativ. Die interne Berechnung verwendet immer absoluten kPa.",
      "ambient_temperature_f": "Umgebungstemp (°F)",
      "ambient_temperature_c": "Umgebungstemp (°C)",
      "sets_base_iat_for_the_physics_loop": "Sets base IAT for the physics loop.",
      "barometric_pressure_kpa": "Barometrischer Druck (kPa)",
      "affects_map_ceiling_and_airmass_scaling_": "Affects MAP ceiling and airmass scaling (altitude).",
      "relative_humidity_": "Relative Feuchtigkeit (%)",
      "used_for_dyno_correction_factor_sae_std": "Used for dyno correction factor (SAE / STD).",
      "coolant_temperature_simulation": "Kühlmitteltemp-Simulation",
      "enable_ect_simulation": "ECT Simulation aktivieren",
      "when_enabled_engine_starts_cold_at_ambie": "Wenn aktiviert, startet der Motor kalt bei Umgebungstemperatur und erwärmt sich auf 90 °C. Deaktiviert = ECT auf 90 °C gesperrt.",
      "o2_sensor_simulation": "O2-Sensor Simulation",
      "enable_o2_transport_delay_amp_combustion": "O2-Transportverzögerung und Verbrennungsrauschen aktivieren",
      "adds_exhaust_transport_delay_to_afr_disp": "Fügt der AFR-Anzeige eine Abgastransportverzögerung hinzu (300ms im Leerlauf, 0ms bei 3500 U/min) und ±3% Verbrennungsvarianz bei niedrigen Drehzahlen.",
      "starter_mode": "Starter-Modus",
      "hold_to_engage_hold_the_button_while_the": "Hold to Engage: hold the button while the starter cranks; release after engine fires.",
      "knock_indicator": "Klopf-Anzeige",
      "show_knock_event_indicator_overlay": "Klopfereignis-Anzeige einblenden",
      "floating_counter_shown_in_all_views_when": "Schwebendes Fenster in allen Ansichten sichtbar, wenn der Motor klopft. Im Erweiterten Modus stattdessen den Reiter Klopfregelung verwenden.",
      "transmission_selection": "Getriebe-Auswahl",
      "export": "EXPORTIEREN",
      "custom_ratios": "Eigene Übersetzungen",
      "final_drive_ratio": "ACHSÜBERSETZUNG",
      "gear_1": "GANG 1",
      "gear_2": "GANG 2",
      "gear_3": "GANG 3",
      "gear_4": "GANG 4",
      "gear_5": "GANG 5",
      "gear_6": "GANG 6",
      "gear_7": "GANG 7",
      "gear_8": "GANG 8",
      "gear_9": "GANG 9",
      "gear_10": "GANG 10",
      "set_ratio_to_0_to_disable_a_gear": "Set ratio to 0 to disable a gear.",
      "apply_simulation_settings": "Simulationseinstellungen anwenden",
      "virtual_dynamometer": "Virtueller Leistungsprüfstand",
      "loads_the_engine_dynamically_to_perform_": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "auto_log_off": "AUTO-LOG AUS",
      "set_as_reference": "ALS REFERENZ SETZEN",
      "hold_n2o": "HALTEN — N2O",
      "smoothing": "GLÄTTUNG:",
      "0_raw": "0 (Roh)",
      "5_max": "5 (Max)",
      "correction": "KORREKTUR:",
      "none": "Keine",
      "sae": "SAE",
      "std": "STD",
      "load_dyno": "Leistungsstand laden",
      "rpm_lock": "RPM Lock",
      "dynojet": "Dynojet",
      "rpms": "RPM/S:",
      "target_rpm": "ZIEL RPM:",
      "afr_guideline": "AFR RICHTLINIE:",
      "start_rpm": "START RPM:",
      "ambient_conditions_advanced_simulation_s": "Ambient conditions: Advanced → Simulation Settings",
      "leaderboard_display_name": "Bestenlisten-Anzeigename",
      "submit_to_leaderboard": "An Bestenliste senden",
      "clutch_0": "KUPPLUNG: 0%",
      "run": "START",
      "launch": "LAUNCH",
      "60ft": "60ft",
      "330ft": "330ft",
      "18_mile": "1/8 Meile",
      "1000ft": "1000ft",
      "14_mile": "1/4 Meile",
      "reaction_time": "Reaktionszeit",
      "9872_check_run_category": "&#9872; Check Run Category",
      "sim_config": "Sim Konfig",
      "weight_lbs": "Gewicht (lbs)",
      "shift_rpm": "Schalt-RPM",
      "shift_delay_s": "Schaltverzögerung (s)",
      "tires": "Reifen",
      "economy": "Economy",
      "street": "Street",
      "summer": "Summer",
      "drag_radials": "Drag Radials",
      "drag_slicks": "Drag Slicks",
      "clutch_slip_s": "Kupplungsschlupf (s)",
      "lb_class": "LB Klasse",
      "run_controls": "Laufsteuerung",
      "start_1x": "START (1x)",
      "ff_3x": "FF (3x)",
      "instant": "SOFORT",
      "shift_up": "HOCHSCHALTEN",
      "abort": "ABBRUCH",
      "n2o": "N2O",
      "manual_mode": "Manueller Modus",
      "no_shift_on_slip": "Kein Schalten bei Schlupf",
      "auto_log": "Auto-Log",
      "hold_cspace_on_line_release_c_to_launch_": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "requirement": "Anforderung:",
      "logged_in": "eingeloggt",
      "advanced_mode": "Advanced Mode",
      "default_vehicle_weight": "Standard-Fahrzeuggewicht",
      "01s_shift_delay": "0.1s Schaltverzögerung",
      "engine": "Motor",
      "category": "Kategorie",
      "stock_economy": "Stock — Economy",
      "stock_street": "Stock — Street",
      "stock_summer": "Stock — Summer",
      "stock_drag_radials": "Stock — Drag Radials",
      "stock_drag_slicks": "Stock — Drag Slicks",
      "mod_na_economy": "Mod N/A — Economy",
      "mod_na_street": "Mod N/A — Street",
      "mod_na_summer": "Mod N/A — Summer",
      "mod_na_drag_radials": "Mod N/A — Drag Radials",
      "mod_na_drag_slicks": "Mod N/A — Drag Slicks",
      "power_adder_economy": "Power Adder — Economy",
      "power_adder_street": "Power Adder — Street",
      "power_adder_summer": "Power Adder — Summer",
      "power_adder_drag_radials": "Power Adder — Drag Radials",
      "power_adder_drag_slicks": "Power Adder — Drag Slicks",
      "super_pa_economy": "Super PA — Economy",
      "super_pa_street": "Super PA — Street",
      "super_pa_summer": "Super PA — Summer",
      "super_pa_drag_radials": "Super PA — Drag Radials",
      "super_pa_drag_slicks": "Super PA — Drag Slicks",
      "search": "Suche",
      "knock_detected": "Klopfen erkannt",
      "0_events": "0 Ereignisse",
      "v001": "v0.0.1",
      "1_2": "1 / 2",
      "times": "×",
      "simple_mode_vs_advanced_mode": "Simple Mode vs Advanced Mode",
      "free": "(Gratis)",
      "purchased": "(Gekauft)",
      "click_here_to_get_advanced_mode_": "Hier klicken für Advanced Mode →",
      "extra_engines_amp_mods": "Zusätzliche Motoren & Mods",
      "click_here_to_browse_engines_": "Hier klicken für Motoren →",
      "click_here_to_browse_mods_": "Hier klicken für Mods →",
      "128274_log_in_to_access_your_purchases": "&#128274; Log In to Access Your Purchases",
      "alphax_account": "AlphaX Konto",
      "alphaxprcom": "alphaxpr.com",
      "controls": "Steuerung",
      "space": "Leertaste",
      "click_drag": "Klicken / Ziehen",
      "click_cell": "Zelle klicken",
      "ctrlz_y": "Strg+Z / Y",
      "table_keyboard_shortcuts": "Tabellen-Tastenkombinationen",
      "arrows": "Pfeiltasten",
      "gt_lt": "&gt; / &lt;",
      "h": "H",
      "v": "V",
      "ctrlc_v": "Strg+C / V",
      "datalogging": "Datenprotokollierung",
      "basic_tuning_tips": "Grundlegende Tuning-Tipps",
      "ignition_timing": "Zündzeitpunkt",
      "target_afr": "Ziel-AFR",
      "map_axis": "MAP Achse",
      "_back": "← Zurück",
      "controls_": "Steuerung →",
      "got_it_": "Verstanden! ✓",
      "run_category_check": "Run Category Check",
      "close": "Schließen",
      "save_your_tune": "Map speichern",
      "you_have_unsaved_tuning_changes": "Nicht gespeicherte Änderungen.",
      "export_your_tune_before_closing_so_you_c": "Export your tune before closing so you can reload it later.",
      "dismiss": "Verwerfen",
      "keep_adjusting": "Weiter anpassen",
      "timing_is_correct_": "Zündung ist korrekt ✓",
      "commanded_wastegate_solenoid_duty_cycle": "Commanded wastegate solenoid duty cycle (0–100%). Higher duty = more boost. Requires a turbocharger mod installed. In Closed-Loop Boost mode this table acts as the feed-forward base; the PID trims on top.",
      "integrates_the_lambda_error_between_actu": "Integrates the lambda error between actual and target AFR each frame and applies a Short-Term Fuel Trim multiplier to correct fueling. Uses your Target AFR table as the setpoint. The integrator gain is",
      "dry_shot_switch_mode_no_ecu_compensation": "Dry shot, switch mode: no ECU compensation is applied. Bake your fuel and timing corrections directly into your VE and timing maps.",
      "sets_the_16_point_rpm_and_map_load_axes": "Sets the 16-point RPM and MAP (load) axes for the VE, AFR, and Timing tables. WG Duty table columns (RPM) also update. The WG Duty row axis (TPS) is unaffected.",
      "keys_hinterp_x_vinterp_y_iinterp_2d_1_ma": "Keys: H=Interp X · V=Interp Y · I=Interp 2D · &gt;/&lt;=±1 · +/-/*=math then Enter · Arrows=navigate · Ctrl+C/V=copy/paste · Ctrl+Z/Y=undo/redo",
      "higher_kp_faster_response_ki_eliminates": "Higher Kp = faster response. Ki eliminates steady-state error. Kd damps overshoot. Live display shows actual° / target° when enabled.",
      "formula_f_573_boremm_81_mm_bore_707_khz": "Formula: f ≈ 573 ÷ bore_mm &nbsp;|&nbsp; 81 mm bore ≈ 7.07 kHz &nbsp;|&nbsp; 102 mm bore ≈ 5.61 kHz",
      "test_your_launch_settings_in_the_garage": "Test your launch settings in the garage. When active, the engine will limit to Launch RPM at full throttle even in Neutral.",
      "hold_cspace_on_line_release_c_to_launch": "Hold C+SPACE on line → release C to launch &nbsp;|&nbsp; SPACE=throttle &nbsp;C=clutch &nbsp;S=shift↑ &nbsp;X=shift↓",
      "ambient_conditions_used_as_the_baseline": "Ambient conditions used as the baseline for all simulations — dyno pulls, drag runs, and the garage physics loop.",
      "mods_include_turbochargers_camshafts_coo": "Mods include turbochargers, camshafts, cooling upgrades, and more — each with real physics effects.",
      "loads_the_engine_dynamically_to_perform": "Loads the engine dynamically to perform a real-time full-throttle sweep from start RPM to redline.",
      "each_engine_has_its_own_power_curve_knoc": "Each engine has its own power curve, knock limits, compression ratio, and tuning maps.",
      "trigger_angle_offset_ecu_360360": "Trigger Angle Offset — ECU (-360–360°)",
      "55_sub_axes_derived_from_the_main_rpm_an": "5×5 sub-axes derived from the main RPM and MAP axes. Scales with the Axis Wizard.",
      "advanced_mode_activates_automatically_wh": "Advanced Mode activates automatically when your purchase is detected at login.",
      "trigger_offset_matches_engine_base_the_t": "Trigger offset matches engine base — the timing mark is perfectly aligned.",
      "inj_mismatch": "Injector size mismatch — check Fuel Settings matches installed injectors",
      "uses_ignition_timing_to_maintain_target": "Uses ignition timing to maintain target idle RPM for faster corrections.",
      "on_the_store_for_the_simulator_to_detect": "on the store for the simulator to detect your purchases and unlock them.",
      "engine_load_in_kpa_higher_more_load_mor": "— engine load in kPa. Higher = more load = more fuel &amp; timing needed",
      "if_you_purchased_something_and_dont_see": "If you purchased something and don't see it, log in to your account on",
      "cyan_noise_level_red_dashed_threshold_at": "Cyan = noise level &nbsp;|&nbsp; Red dashed = threshold at current RPM",
      "torque_bonus_0_at_145_v_3_at_125_v_reduc": "Torque bonus: 0% at 14.5 V → +3% at 12.5 V (reduced alternator drag).",
      "extra_injection_ms_on_tip_in_y_tps_rate": "Extra injection ms on tip-in. Y = TPS rate of change (%/s), X = RPM.",
      "your_purchased_engines_mods_and_advanced": "Your purchased engines, mods, and Advanced Mode are tied to your",
      "logs_include_rpm_map_afr_timing_ve_torqu": "Logs include RPM, MAP, AFR, timing, VE, torque, boost, and more",
      "advance_for_power_but_watch_for_knock_t": "— advance for power, but watch for knock. Typical MBT is 25–35°",
      "degrees_before_top_dead_center_too_much": "Degrees Before Top Dead Center. Too much advance causes knock.",
      "of_maximum_idle_tps_to_command_at_each": "% of Maximum Idle TPS% to command at each coolant temperature.",
      "richer_11121_under_boostwot_stoich_1471": "— richer (11–12:1) under boost/WOT, stoich (14.7:1) at cruise",
      "controls_fuel_delivery_aim_for_1471_afr": "— controls fuel delivery. Aim for ~14.7:1 AFR at cruise",
      "to_submit_runs_must_use": "to submit. \n                            Runs must use",
      "flood_hint": "Hold throttle to floor while cranking to clear flood",
      "affects_map_ceiling_and_airmass_scaling": "Affects MAP ceiling and airmass scaling (altitude).",
      "select_an_engine_and_category_to_view_le": "Select an engine and category to view leaderboards.",
      "degrees_recovered_per_engine_revolution": "Degrees recovered per engine revolution. 0.1–2.0",
      "enable_o2_transport_delay_combustion_noi": "Enable O2 Transport Delay &amp; Combustion Noise",
      "focus_math_input_type_value_enter_to_ap": "— Focus math input → type value → Enter to apply",
      "start_dyno_pull": "START DYNO PULL",
      "drag_strip_leaderboards": "Drag Strip Leaderboards",
      "copy_paste_selection_as_spreadsheet_dat": "— Copy / paste selection as spreadsheet data",
      "to_start_recording_stops_and_exports_a_c": "to start recording — stops and exports a CSV",
      "10003_ve_timing_target_afr_tables": "&#10003; VE, Timing &amp; Target AFR tables",
      "10003_flex_fuel_tables_e85_physics": "&#10003; Flex Fuel tables &amp; E85 physics",
      "interpolate_horizontally_across_selecti": "— Interpolate horizontally across selection",
      "cranking_idle_air_duty_vs_coolant_temp": "Cranking Idle Air Duty vs Coolant Temp (%)",
      "interpolate_vertically_across_selection": "— Interpolate vertically across selection",
      "available_in_garage_dyno_and_drag_modes": "Available in Garage, Dyno, and Drag modes",
      "ms_mode_mss_map_mode_blends": "MS mode: ms/s &middot; MAP mode: blend/s",
      "map_prediction_tps_vs_rpm_kpa": "MAP Prediction (TPS % vs RPM &rarr; kPa)",
      "10003_engine_damage_failure_rng": "&#10003; Engine damage &amp; failure RNG",
      "timing_is_correct": "Timing is Correct ✓",
      "imperial_f_psi_mph": "Imperial (°F &middot; PSI &middot; MPH)",
      "move_selection_hold_shift_to_extend": "— Move selection (hold Shift to extend)",
      "interpolate_2d_entire_selected_area": "— Interpolate 2D (entire selected area)",
      "select_a_dry_or_wet_shot_system_under": "Select a Dry or Wet Shot System under",
      "10003_launch_control_two_step": "&#10003; Launch control &amp; two-step",
      "add_subtract_1_from_selected_cells": "— Add / subtract 1 from selected cells",
      "target_voltage_v_rpm_vs_map_kpa": "Target Voltage (V) — RPM vs MAP (kPa)",
      "to_get_them": "to get them!",
      "metric_c_kpa_kph": "Metric (°C &middot; kPa &middot; KPH)",
      "10003_knock_detection_retard": "&#10003; Knock detection &amp; retard",
      "ms_adder_dtps_s_vs_rpm_ms": "MS Adder (dTPS %/s vs RPM &rarr; ms)",
      "to_qualify": "to qualify.",
      "10003_everything_in_simple_plus": "&#10003; Everything in Simple, plus:",
      "10003_accel_enrichment_ms_map": "&#10003; Accel enrichment (ms / MAP)",
      "tps_5_rpm_near_idle_target": "(TPS &lt; 5%, RPM near idle target)",
      "10003_dyno_drag_simulation": "&#10003; Dyno &amp; Drag simulation",
      "10003_coil_dwell_misfire_physics": "&#10003; Coil dwell misfire physics",
      "10003_vvt_vvl_cam_control": "&#10003; VVT &amp; VVL cam control",
      "10003_closed_loop_boost_control": "&#10003; Closed-loop boost control",
      "calibrated_center_frequency": "✓ Calibrated — center frequency:",
      "need_some_mods_head_over_to_the": "Need some mods? Head over to the",
      "10003_datalogging_csv_export": "&#10003; Datalogging (CSV export)",
      "10003_o2_sensor_delay_modeling": "&#10003; O2 sensor delay modeling",
      "10003_drag_racing_leaderboards": "&#10003; Drag racing leaderboards",
      "click_here_to_get_advanced_mode": "Click Here to get Advanced Mode →",
      "dont_show_again": "Don't show again",
      "map_load_axis_16_points_kpa": "MAP / Load Axis (16 points, kPa)",
      "flex_fuel_boost_duty_adder": "Flex Fuel Boost Duty Adder (%)",
      "10003_basic_closed_loop_afr": "&#10003; Basic closed-loop AFR",
      "click_here_to_browse_engines": "Click Here to browse Engines →",
      "idle_duty_vs_coolant_temp": "Idle Duty vs Coolant Temp (%)",
      "10003_tune_import_export": "&#10003; Tune import / export",
      "10003_smart_alternator_pid": "&#10003; Smart alternator PID",
      "no_nitrous_system_installed": "No nitrous system installed.",
      "10003_fuel_pressure_model": "&#10003; Fuel pressure model",
      "click_here_to_browse_mods": "Click Here to browse Mods →",
      "edit_a_tuning_table_value": "— Edit a tuning table value",
      "iat_timing_retard_by_iat": "IAT Timing Retard (by IAT",
      "vvl_high_cam_min_tps": "VVL / High Cam Min TPS (%)",
      "10003_idle_ignition_pid": "&#10003; Idle ignition PID",
      "extra_engines_mods": "Extra Engines &amp; Mods",
      "then_reload_this_page": ", then reload this page.",
      "hold_to_rev_the_engine": "— Hold to rev the engine",
      "ect_fuel_enrichment": "ECT Fuel Enrichment (×)",
      "10003_decel_fuel_cut": "&#10003; Decel fuel cut",
      "flex_fuel_ve_adder": "Flex Fuel VE Adder (%)",
      "iat_ve_comp_by_iat": "IAT VE Comp% (by IAT",
      "min_tps_to_engage": "Min TPS to Engage (%)",
      "vvl_fuel_adder_ve": "VVL Fuel Adder (VE %)",
      "voltage_regulator_pid": "Voltage Regulator PID",
      "relative_humidity": "Relative Humidity (%)",
      "modified_violations": "Modified+ violations:",
      "vvl_timing_adder": "VVL Timing Adder (°)",
      "rpm_axis_16_points": "RPM Axis (16 points)",
      "active_session_id": "Active Session ID:",
      "ethanol_content": "Ethanol Content (%)",
      "min_correction": "Min Correction (%)",
      "max_correction": "Max Correction (%)",
      "fuel_adder_afr": "Fuel Adder (AFR %)",
      "fuel_ve_comp": "Fuel VE Comp. (%)",
      "timing_retard": "Timing Retard (°)",
      "9888_red_light": "&#9888; RED LIGHT",
      "and_a_minimum_of": "and a minimum of",
      "timing_locked_in": "Timing Locked In!",
      "1_timeconstant": "1 / timeConstant",
      "throttle_pedal": "— Throttle pedal",
      "5_seconds_ago": "← 5 seconds ago",
      "live_telemetry": "LIVE TELEMETRY",
      "tps_90": "(TPS &gt; 90%)",
      "hold_to_engage": "Hold to Engage",
      "peak_boost": "PEAK BOOST: --",
      "ready_to_stage": "READY TO STAGE",
      "running_mode": "Running Mode",
      "push_to_start": "Push to Start",
      "undo_redo": "— Undo / Redo",
      "to_run_stock": "To run Stock:",
      "not_you": "! Not you? (",
      "firing_order": "FIRING ORDER",
      "deadband": "Deadband (%)",
      "you_must_be": "You must be",
      "simple_mode": "Simple Mode",
      "distributor": "DISTRIBUTOR",
      "n2o_active": "N2O: ACTIVE",
      "fuel_air": "Kraftstoff & Luft",
      "vvt_cams": "VVT & Nockenwellen",
      "min_tps": "Min TPS (%)",
      "peak_hp": "PEAK HP: --",
      "peak_tq": "PEAK TQ: --",
      "clutch_slip": "CLUTCH SLIP",
      "clutch_fail": "CLUTCH FAIL",
      "vvl_vtec": "VVL / VTEC",
      "idle_mode": "Idle Mode",
      "ref_hp": "REF HP: --",
      "ref_tq": "REF TQ: --",
      "and_using": "and using",
      "decel_cut": "DECEL CUT",
      "ignition": "Zündung",
      "advanced": "Erweitert",
      "wot_mode": "WOT Mode",
      "337_hp": "≈ 33.7 HP",
      "got_it": "Verstanden! ✓",
      "idle_pid": "IDLE PID",
      "timeslip": "TIMESLIP",
      "psi": "-- PSI",
      "setup": "Einstellungen",
      "player": "Player",
      "click": "Click",
      "back": "← Zurück",
      "25s": "-2.5s",
      "for": "° for",
      "speed": "SPEED",
      "accel": "BESCHL",
      "slip": "SCHLUPF!",
      "time": "ZEIT",
      "gear": "GANG",
      "mods": "Mods",
      "tdc": "OT",
      "mph": "MPH",
      "mod_intake": "Ansaugung",
      "mod_intake_manifold": "Ansaugkrümmer",
      "mod_exhaust_manifold": "Abgaskrümmer",
      "mod_exhaust": "Auspuff",
      "mod_port_and_polish": "Kanäle bearbeiten",
      "mod_turbocharger": "Turbolader",
      "mod_supercharger": "Kompressor",
      "mod_camshaft": "Nockenwelle",
      "mod_pistons": "Kolben",
      "mod_rods": "Pleuel",
      "mod_clutch": "Kupplung",
      "mod_intercooler": "Ladeluftkühler",
      "mod_fuel_pump": "Kraftstoffpumpe",
      "mod_fuel_injector": "Einspritzdüse",
      "stock_none": "Serie / Keine",
      "dry_shot_system": "Dry Shot System",
      "wet_shot_system": "Wet Shot System",
      "buy_nitrous_kit": "Nitro-Kit kaufen!",
      "mod_settings": "Mod-Einstellungen",
      "wastegate_spring_psi": "Wastegate-Feder (psi)",
      "wastegate_spring_kpa": "Wastegate-Feder (kPa)",
      "map_axes_scale_help": "MAP-Achsen skalieren auf 2× Federdruck.",
      "closed_loop_boost": "Closed-Loop Boost",
      "pulley_ratio": "Riemenscheibenverhältnis (SC/Motor)",
      "bypass_threshold": "Bypass-Schwelle (%)",
      "max_sc_rpm": "Max SC RPM:",
      "twin_turbo_setup": "Twin-Turbo-Setup",
      "twin_turbo_help": "(×1.9 Luftstrom, ~½× Spool-Rate)",
      "custom_transmission": "Eigenes Getriebe",
      "applied": "Angewendet!",
      "stop_engine": "MOTOR STOPPEN",
      "flooded": "ABGESOFFEN",
      "no_start_trigger": "KEIN START: TRIGGER-WINKEL",
      "no_start_lean": "KEIN START: ZU MAGER",
      "stalled": "ABGEWÜRGT",
      "stalled_rpm": "ABGEWÜRGT: RPM unter Cranking-Geschwindigkeit gefallen.",
      "stalled_battery": "ABGEWÜRGT: Batteriespannung kritisch niedrig (8 V).",
      "submitting": "Übermittlung...",
      "submitted": "Übermittelt!",
      "error_retry": "Fehler (Wiederholen)"
    }
  }
};